import styled from 'styled-components';

export const TemplateWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

export default TemplateWrapper;
